"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkList = LinkList;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _links = require("../../fuse-link/src/links");
var _styledLinkList = _interopRequireDefault(require("./styled-link-list"));
var _excluded = ["links", "className", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  className: 'fuse-link-list',
  dataTestId: 'fuse-link-list-test-id'
};
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    href: _propTypes["default"].string.isRequired,
    text: _propTypes["default"].string.isRequired
  })).isRequired
};
function LinkList(_ref) {
  var links = _ref.links,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledLinkList["default"], _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-link-list-test-id'
  }, props), links.map(function (link, i) {
    return /*#__PURE__*/_react["default"].createElement(_links.Link
    // eslint-disable-next-line react/no-array-index-key
    , _extends({
      key: i,
      href: link.href,
      className: "fuse-link-list__link",
      "data-testid": "fuse-link-list-link-".concat(i)
    }, link), link.text);
  }));
}
LinkList.propTypes = propTypes;
LinkList.defaultProps = defaultProps;
var _default = exports["default"] = LinkList;